import { render, staticRenderFns } from "./AddNewKey.vue?vue&type=template&id=52907f08&"
import script from "./AddNewKey.vue?vue&type=script&lang=js&"
export * from "./AddNewKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports